import { ReactNode } from 'react';
import classNames from 'classnames';

import { useSortByUrl } from '../hooks/use-sort-by-url';

import { StyledTh } from './admin-styled-components';

interface Props {
  value: string;
  children: ReactNode;
}

export const TableHeaderButton = ({ value, children }: Props) => {
  const { sortType, sortValue, handleSortChange } = useSortByUrl();

  return (
    <StyledTh
      className={classNames({
        [sortType]: sortValue === value,
      })}
      onClick={handleSortChange(value)}
      isButton
    >
      {children}
    </StyledTh>
  );
};
